/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Review_HInputs */

const en_wc_tut_review_h = /** @type {(inputs: Wc_Tut_Review_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Track changes and comments`)
};

/**
* | output |
* | --- |
* | "5. Track changes and comments" |
*
* @param {Wc_Tut_Review_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_review_h = /** @type {((inputs?: Wc_Tut_Review_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Review_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_review_h(inputs)
});
export { wc_tut_review_h as "wc.tut.review.h" }